import { IState } from 'shared/store';
import { IOfferDiscount } from 'shared/types/offerDiscount';

export function getOfferDiscount(state: IState): IOfferDiscount | undefined {
  return state.offerData?.discount;
}
